<template>
  <div class="remoteUpgrade">
    <box ref="box"></box>
    <el-card shadow="never" :style="style" class="el-card">
      <el-upload
          class="btn5"
          action="no"
          :show-file-list=false
          :http-request="handleUpgradeFile">
        <el-button type="primary" :loading="upgrading">{{ $t('upgradeFile') }}</el-button>
      </el-upload>
      <span class="title-btn" v-show="!tableShow" @click="handleRefresh">
      <!-- <el-button type="primary" :loading="searching">刷新</el-button> -->
    </span>
      <div v-show="!tableShow" class="uploadBox" :style="{height: `${this.bottomHeight}px`}">
        <div class="uploadBox-img">
          <el-image
              class="image"
              :src="direction === 1 ? up : down"
              :fit="fit">
          </el-image>
          <div class="progress">
            <div class="name" v-show="direction === 1">{{ $t('sendToControllerProgress') }}</div>
            <div class="name" v-show="direction === 2">{{ $t('controllerUploadProgress') }}</div>
            <div class="value" v-show="statusRefresh == 1">{{ current }}</div>
            <div class="value" v-show="statusRefresh == 0">{{ $t('success') }}</div>
            <div class="fail" v-show="statusRefresh == 2">{{ $t('fail') }}</div>
          </div>
          <div class="btn-pro">
            <el-button @click="handleConfirm" v-show="isShowCon">{{$t('confirm')}}</el-button>
            <el-button v-show="!isShowCon" @click="handleCancel">{{$t('cancel')}}</el-button>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import Box from "@/components/Box";
import {upgrade} from "api/install";
import {deleteSchedule, getSchedule,getRefresh,compelte,cancel} from "@/api/query"
import up from 'assets/img/box/up.png'
import down from 'assets/img/box/down.png'
import Status from "components/Status";

export default {
  name: "remoteUpgrade",
  mixins: [Status],
  components: {
    Box
  },
  data() {
    return {
      searchForm: {
        controllerNo: '',
        loopNo: '',
        siteInitiation: ''
      },
      bottomHeight: null,
      showTable: true,
      currentIndex: 0,
      style: null,
      fit: 'contain',
      tableShow: true,
      isShowCon:false,
      searching:false,
      upgrading:false,
      direction:1,
      current:0,
      statusRefresh:1,
      up:up,
      down:down
    }
  },
  mounted() {
    this.calcHeight()
    this.handleRefresh()
  },
   beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getSchedule()
    })
  },
  computed: {
    controllInfo() {
      return this.$store.state.controlInfo
    }
  },
  methods: {
    calcHeight() {
      setTimeout(() => {
        this.bottomHeight = this.$refs.box.$el.clientHeight + 'px'
        this.style = `height: calc(100vh - 100px - ${this.bottomHeight})`
      }, 20)
    },
    _deleteSchedule() {
      deleteSchedule({
        controllerPsn: this.controllInfo.controllerPsn,
        type: 3
      }).then((res) => {
        if (res.code === 1) {
          this.$message.success(res.message)
          this.tableShow = true
        }
      })
    },
     watch:{
      $route:{
            handler(val,oldval){
                clearInterval(this.timer)
            },
            deep: true
          },
    },
   beforeDestroy(){
    if (this.timer) {
      clearInterval(this.timer)
    }
    },
    handleUpgradeFile(val) {
      this.upgrading = true
      this.show()
      let params = {
        file: val.file,
        controllerPsn: this.controllInfo.controllerPsn
      }
      upgrade(params).then((res) => {
        // 调用进度接口
        if (res.code === 1) {
          // 接口返回成功即可显示对勾，1:descr 2:program 3:upgrad 4:history
          this.success(res.message ? res.message : '操作成功')
          this.upgrading = false
          this.getSchedule()
        }
      }).catch(() => {
        this.failed()
        this.upgrading = false
      })
    },
    getSchedule(){
      getSchedule({
            controllerPsn: this.controllInfo.controllerPsn,
            type: 3
          }).then((res) => {
            if (res.code === 1) {
              //this.$message.info(res.message)
              this.statusRefresh = res.data.state
              if (res.data.current) {
                this.current = res.data.current / res.data.total * 100
                this.current = this.current.toFixed(2)
              } else {
                this.current = 0
              }
              if (res.data.current === 0 && res.data.total === 0) {
                this.current = 1
              }
              const _this = this
              this.timer = setInterval(() => {
                if (res.data.state === 0 || res.data.state === 2) {
                this.isShowCon = true
                clearInterval(this.timer)
                } else if (res.data.state === 1) {
                this.isShowCon = false
                _this.handleRefresh()
                }
            }, 2000)
              this.direction = res.data.direction
              this.tableShow = false
            }
          })
    },
    //刷新
    handleRefresh() {
      this.searching = true
    getRefresh({
            controllerPsn: this.controllInfo.controllerPsn,
            type: 3
          }).then((res) => {
            this.searching = false
            if (res.data == null) {
              this.tableShow = true
            } else {
              this.tableShow = false
            if (res.code === 1) {
                //this.$message.success('操作成功')
                if (res.data.state === 0 || res.data.state === 2){
                    //this.current = 100
                    clearInterval(this.timer)
                    this.isShowCon = true
                }
                const data = res.data
                    if (data) {
                      this.statusRefresh = res.data.state
                      this.current = data.current / data.total * 100
                      this.current = this.current.toFixed(2)
                      this.direction = res.data.direction
                    }
              }
              }
          })
    },
    //确定
    handleConfirm() {
      compelte({
        controllerPsn: this.controllInfo.controllerPsn,
        type: 3
      }).then((res) => {
        if (res.code === 1) {
          this.tableShow = true
          this.isShowCon = false
          this.$message.success('操作成功')
        }
      })
    },
    //取消
    handleCancel() {
      cancel({
        controllerPsn: this.controllInfo.controllerPsn,
        type: 3
      }).then((res) => {
        if (res.code === 1) {
          this.tableShow = true
          this.isShowCon = false
          this.$message.success('操作成功')
          clearInterval(this.timer)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-card {
  position: relative;

  .title-btn {
    position: absolute;
    left: 133px;
    top: 19px;
    color: #00BEFF;
  }

  .uploadBox {
    position: absolute;
    left:45%;
    top:50%;
  }
  .btn-pro{
    margin-left: 120px;
  }
  .progress{
    display: flex;
        margin-left: 73px;
    .name1{
      margin-left: 80px;
    }

    .btn-pro {
      margin-left: 74px;
    }
      // color: #959595;
      // height: 30px;
      .name {
        display: inline-block;
        padding: 5px 0;
      }

      .value {
        padding-left: 10px;
        display: inline-block;
        line-height: 30px;
        height: 30px;
        color: #00BEFF;
      }

      .fail {
        padding-left: 10px;
        display: inline-block;
        line-height: 30px;
        height: 30px;
        color: red;
      }
  }
}
</style>
